import React from 'react';
import {
    DECISION_PERIMETER,
    DecisionPerimeterT,
} from './ModuleForm/helpers/definitions';
import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import sortBy from 'lodash/sortBy';

const DecisionPerimeters = ({
    decisionPerimeters,
    setDecisionPerimeters,
}: {
    decisionPerimeters: DecisionPerimeterT[];
    setDecisionPerimeters: (s: DecisionPerimeterT[]) => void;
}) => {
    const { t } = useTranslation();

    // We want to sort the options alaphabetically, but in regard to
    // their translation, not their values.
    const options = sortBy(DECISION_PERIMETER, (perim) => t(`cellar.${perim}`));

    return (
        <Autocomplete
            multiple
            options={options}
            value={decisionPerimeters}
            onChange={(_ev, value) =>
                setDecisionPerimeters(value as DecisionPerimeterT[])
            }
            noOptionsText={t('common.noResult')}
            getOptionLabel={(val) => t(`cellar.${val}`)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={t('backoffice.decisionPerimeterLabel')}
                />
            )}
        />
    );
};

export default DecisionPerimeters;
